<template>
  <div class="service-list">
    <div class="service-list__content">
      <div
        v-for="data in getServiceData"
        :key="data.id"
        class="service-item"
        :class="{
          'service-item--active': getChangedServiceArr.find(
            (item) => item.id === data.id
          ),
        }"
        @click="add(data)"
      >
        <div class="service-item__icon">
          <img src="images/icons/bitcoin.svg" alt="icon" />
        </div>
        <div class="service-item__description">
          <p>
            {{ data.description }} <span>{{ data.price }}₴</span>
          </p>
        </div>
        <div class="service-item__button">
          <div class="select-button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: mapGetters("registration", [
    "getServiceData",
    "getChangedServiceArr",
  ]),
  methods: {
    ...mapMutations("registration", ["TOGLE_CHANGED_SERVICE"]),
    ...mapMutations("dropdown", ["SET_DROPDOWN_DATA", "REMOVE_DROPDOWN_ITEM"]),
    add(data) {
      this.TOGLE_CHANGED_SERVICE(data);

      if (this.getChangedServiceArr.length) {
        this.SET_DROPDOWN_DATA({
          text: null,
          description: null,
          img: null,
          active: true,
          index: 2,
        });
      } else {
        this.REMOVE_DROPDOWN_ITEM(2);
      }
    },
  },
};
</script>

<style lang="scss">
.service-list {
  display: flex;
  flex-direction: column;
  row-gap: 40px;

  &__content {
    display: flex;
    flex-direction: column;
    row-gap: 14px;
  }
}
.service-item {
  display: flex;
  justify-content: space-between;
  height: 58px;
  border-radius: 100px;
  border: 1px solid rgba(200, 200, 200, 0.2);

  &__icon {
    display: flex;
    align-items: center;
    padding: 0 17px;
    border-right: 1px solid rgba(200, 200, 200, 0.2);
  }

  &__description {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 12px;
    cursor: pointer;

    p {
      font-size: 15px;
      font-weight: 500;

      span {
        font-weight: 700;
        color: #378209;
      }
    }
  }

  &__button {
    display: flex;
    align-items: center;
    padding: 0 13px;
    border-left: 1px solid rgba(200, 200, 200, 0.2);
  }

  &--active {
    background: #fff;

    .select-button {
      background: none;

      &::before {
        background: #000;
      }

      &::after {
        background: #000;
        transform: translate(-50%, -50%) rotate(0deg);
      }
    }
  }
}

.select-button {
  position: relative;
  width: 32px;
  height: 32px;
  border: 1px solid #000;
  border-radius: 50%;
  background: #000;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(0deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(90deg);
    transition: transform 0.3s;
  }
}
</style>
